export function tariffsList()
{
    return axios({
        url: '/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/home/tariffs',
        method: 'get',
    });
}

export function list(homeType, insuranceAmount, insurancePeriod, startDate, earning)
{
    return axios({
        url: '/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/home/calculator',
        method: 'post',
        data: {
            homeType: homeType,
            insuranceAmount: insuranceAmount,
            insurancePeriod: insurancePeriod,
            startFrom: startDate,
            earnings: earning,
        },
    });
}
